require('./intervention-antenniste.scss');

import DemandeActions from '../../../../actions/demande.actions';
import { STEPS } from '../../../../utils/routes.util';

export default class InterventionAntennisteComponent {
  constructor() {
    this.controller = InterventionAntennisteController;
    this.template = require('./intervention-antenniste.html');
  }
}

// @ngInject
class InterventionAntennisteController {

  constructor($scope, $ngRedux) {
    this.$ngRedux = $ngRedux;
    this.$scope = $scope;
    this.data = {};
  }

  $onInit() {
    // Demande de récupération de la demande avant connexion au state
    this.$ngRedux.dispatch(DemandeActions.loadDemande(STEPS.INTERVENTION_ANTENNISTE));
    // Connexion au state récupérer les données modifiées
    const disconnect = this.$ngRedux.connect(
      state => {
        return {
          working: state.general.working,
          failure: state.demande.failure,
          fetching: state.demande.fetching,
          data: state.demande.data.interventionAntenniste ? state.demande.data.interventionAntenniste.asMutable({deep: true}) : this.data
        };
      }
    )(this);

    // Déconnexion du state à la suppression du composant
    this.$scope.$on('$destroy', disconnect);
  }

  // Actions
  prevStep() {
    this.$ngRedux.dispatch(DemandeActions.updateInterventionAntenniste(this.data, true));
  }
  nextStep(source) {
    this.data.source = source;
    this.$ngRedux.dispatch(DemandeActions.updateInterventionAntenniste(this.data));
  }
}



// WEBPACK FOOTER //
// ./src/modules/accueil/components/intervention-antenniste/intervention-antenniste.component.js